import React from "react";
import TableBody from "@mui/material/TableBody";
import TableContainer from "component/table/TableContainer";
import Table from "component/table/Table";
import { EntityIdentifier } from "module/entity/types";
import ListToolbarContainer from "module/listToolbar/ListToolbarContainer";
import t from "module/translations";
import { getEntityIdentifierKey } from "module/entity/helper/getEntityIdentifierKey";
import InventoryCheckListTableHeadContainer from "./table/head/InventoryCheckListTableHeadContainer";
import InventoryCheckListTableRowContainer from "./table/row/InventoryCheckListTableRowContainer";

interface Props {
  entityIdentifiers: EntityIdentifier[];
}

const InventoryCheckList: React.FC<Props> = ({ entityIdentifiers }) => {
  return (
    <TableContainer>
      <ListToolbarContainer
        {...{
          title: t.routes.inventoryChecksOnline,
          isDownloadAvailable: true,
        }}
      />
      <Table>
        <InventoryCheckListTableHeadContainer />
        <TableBody>
          <>
            {entityIdentifiers.map((entityIdentifier) => (
              <InventoryCheckListTableRowContainer
                {...{
                  key: getEntityIdentifierKey(entityIdentifier),
                  entityIdentifier,
                }}
              />
            ))}
          </>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default React.memo(InventoryCheckList);
